<ngx-avatar
  [name]="profile.given_name + ' ' + profile.family_name"
  [gravatarId]="profile.email"
  [size]="50"
  matTooltip="Please visit https://en.gravatar.com/ to set up a profile picture"
  matTooltipPosition="above"
></ngx-avatar>
